module.exports = __webpack_public_path__ + "img/sgcc-black.303c1c15.png";